import { LoginHelper } from "../../../utils/LoginHelper";
import { isFreeProduct } from "../../common/badge/FreeBadge";

/** سخنران / مالک وبینار (حتی اگر API قدیمی is_owner نفرستد) */
export function isWebinarSpeaker(webinar) {
	if (!webinar) return false;
	if (webinar.is_owner) return true;
	const myId = LoginHelper.getProfileId();
	const ownerId = webinar.profile_detail?.id ?? webinar.profile;
	if (myId == null || ownerId == null) return false;
	return String(myId) === String(ownerId);
}

/** ثبت‌نام / خرید / رایگان / سخنران — همان منطق has_access در بک‌اند */
export function userHasWebinarJoinAccess(webinar) {
	if (!webinar) return false;
	if (webinar.has_access === true) return true;
	return (
		isWebinarSpeaker(webinar) ||
		Boolean(webinar.is_enroll) ||
		isFreeProduct(webinar)
	);
}

export function userIsWebinarRegistered(webinar) {
	if (!webinar) return false;
	if (webinar.is_enroll || webinar.has_access) return true;
	return userHasWebinarJoinAccess(webinar) && !isWebinarSpeaker(webinar);
}

export function webinarHasStarted(webinar) {
	if (!webinar) return false;
	if (typeof webinar.has_started === "boolean") {
		return webinar.has_started;
	}
	return (
		(webinar.diff_second ?? 0) === 0 &&
		!webinar.is_enrollable &&
		!isFreeProduct(webinar)
	);
}

export function webinarJoinWindowOpen(webinar) {
	if (!webinar) return false;
	if (typeof webinar.is_join_window_open === "boolean") {
		return webinar.is_join_window_open;
	}
	return false;
}

export const WEBINAR_JOIN_ENDED_REGISTERED_MESSAGE =
	"ثبت‌نام شما انجام شده است. زمان ورود به اتاق برگزاری به پایان رسیده است.";

export const WEBINAR_EVENT_PAST_MESSAGE =
	"زمان برگزاری این وبینار گذشته است.";
